import React from "react";

const FeedbackButton = ({ onClick }) => {
  return (
    <div className="feedback-link">
      <button onClick={onClick}>Send Feedback</button>
    </div>
  );
};

export default FeedbackButton;
